import React, { Component } from "react";
import { Button, Container, Menu, Image } from "semantic-ui-react";

import * as LINKS from "../assets/Links";
import LOGO from "../assets/images/logo.png";

import * as CONSTANTS from "../assets/Constants";

class MenuItems extends Component {
  constructor(props) {
    super(props);
    this.displayRecruitment = true;
    this.displaySignUp = CONSTANTS.displaySignUp;
  }
  toggleDisplayRecruitment = () => {
    if (this.props.displayRecruitment) {
      this.displayRecruitment = false;
    }
  };
  render() {
    let recruitment;
    if (this.props.displayRecruitment) {
      recruitment = (
        <Menu.Item
          as="a"
          href="#/recruitment"
          active={this.props.activeItem === "recruitment"}
        >
          Recruitment
        </Menu.Item>
      );
    }
    let signUp;
    if (this.displaySignUp) {
      signUp = (<Button as='a' href="#/v4ffZutsJVvTT9" inverted={!this.props.fixed} basic style={{ marginLeft: '0.5em' }}>
                                             Sign Up
                                         </Button>);
    }
    return (
      <Container>
        {/* {console.log(this.props.activeItem)}` */}
        <Menu.Item
          as="a"
          href="#/"
          active={this.props.activeItem === "home"}
          style={{ backgroundColor: "#111111" }}
        >
          {/* Home */}
          <Image src={LOGO} size="mini" />
        </Menu.Item>
        <Menu.Item
          as="a"
          href="#/team"
          active={this.props.activeItem === "team"}
        >
          Team
        </Menu.Item>
        <Menu.Item
          as="a"
          href="#/gallery"
          active={this.props.activeItem === "gallery"}
        >
          Gallery
        </Menu.Item>
        <Menu.Item
          as="a"
          href="#/projects"
          active={this.props.activeItem === "projects"}
        >
          Projects
        </Menu.Item>
        <Menu.Item
          as="a"
          href={LINKS.MEDIUM_BLOGS_LINK}
          target="_blank"
          rel="noopener noreferrer"
        >
          Blogs
        </Menu.Item>
        {recruitment}
        <Menu.Item position="right">
          <Button as="a" href="#/login" inverted={!this.props.fixed}>
            Log in
          </Button>
                {signUp}
      {/*
//           <Button as='a' href="#/VYr6Wzy8Tc" inverted={!this.props.fixed} basic style={{ marginLeft: '0.5em' }}>
//                                             Sign Up
//                                         </Button>
*/}

        </Menu.Item>
      </Container>
    );
  }
}

export default MenuItems;
